<template>
  <div>
    <vs-pagination
      :total="pageCount"
      v-model="meta.current_page"
      @change="handlePageChange(meta.current_page)"
      :max="pageCount > 9 ? 9 : pageCount"
      vs-type="flex"
    ></vs-pagination>
  </div>
</template>
<script>
export default {
  name: 'Pagination',
  props: {
    meta: {
      default: () => {
        return {
          current_page: 1,
          has_next: true,
          limit: 20,
          next_page_url: '',
          previous_page_url: null,
          total: 0
        }
      }
    }
  },
  data () {
    return {}
  },
  computed: {
    pageCount () {
      const _temp = Math.ceil(this.meta.total / this.meta.limit)
      return _temp
    }
  },
  methods: {
    handlePageChange (page) {
      this.$emit('page-change', page)
    }
  }
}
</script>
